import styled from 'styled-components'

import { ButtonPill } from '@fortum/elemental-ui'

export const CustomButtonPill = styled(ButtonPill)`
  span {
    overflow-wrap: break-word;
  }
`
